<template>
    <div class="contain desFile">
        <!-- <div class="header-box">
            项目端-专户管理-文件夹/文件
        </div> -->
        <div class="header-box">
            <el-page-header @back="goBack" content="专户信息模板"></el-page-header>
            <el-button type="primary" @click="addFormVisible=true">添加文件夹</el-button>
        </div>
        <div class="box">
            <div class="box-content flex-wrap">
                <div class="table-item" style="height:100%;">
                    <div style="flex:1;display:flex;flex-wrap: wrap;height: 220px;" class="item-con">
                        <div style="width:150px;display:flex;flex-wrap:wrap;align-content: flex-start;" v-for="child in dataList" :key="child.id">
                            <p v-if="child.fileType!='0'" class="title nowrap" style="width:100%;" :title="child.attachmentName">{{child.filesName}}</p>
                            <p  style="width:100%;">
                                <img v-if="child.fileType=='0'" style="width:100px;height:100px;" src="../../../assets/image/file.png" @click="showChild(child.id,child.filesName)" />
                                <img v-if="child.fileType=='1'" style="width:50px;height:50px;" src="../../../assets/image/office/word.png" @click="showFile(child.filesAddress,child.filesName)" />
                                <img v-else-if="child.fileType=='2'" style="width:50px;height:50px;" src="../../../assets/image/office/excel.png" @click="showFile(child.filesAddress,child.filesName)" />
                                <img v-else-if="child.fileType=='3'" style="width:50px;height:50px;" src="../../../assets/image/office/pdf.png" @click="showFile(child.filesAddress,child.filesName)" />
                                <img v-else-if="child.fileType=='4'" style="width:50px;height:50px;" src="../../../assets/image/office/photo.png" @click="showFile(child.filesAddress,child.filesName)" />
                                <img v-else-if="child.fileType=='5'" style="width:50px;height:50px;" src="../../../assets/image/office/undefined.png" @click="showFile(child.filesAddress,child.filesName)" />
                            </p>
                            <p v-if="child.fileType!='0'" style="width:100%;"><img style="width:40px;height:40px;" src="../../../assets/image/downfile.png" @click="downFile(child.filesAddress)" /></p>
                            <p v-if="child.fileType=='0'" class="name nowrap" style="width:100%;">{{child.filesName}}</p>
                            <!-- <p v-if="child.fileType!='0'" class="name" style="width:100%;">{{child.userName}}上传</p>
                            <p v-if="child.fileType!='0'" class="time" style="width:100%;">{{child.createDate}}</p> -->
                        </div>
                        <div style="width:150px;display:flex;flex-wrap:wrap;align-content: flex-start;justify-content: center;align-items: center;padding-top: 45px;">
                            <el-upload
                              class="upload-demo"
                              v-bind:action="uploadUrl"
                              :headers="uploadHead"
                              :data={type:237}
                              :show-file-list="false"
                              :on-success="fileSuccess1">
                                <el-button size="small" class="primary">点击上传</el-button>
                            </el-upload>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 新增窗口 -->
            <el-dialog
                title="添加文件夹"
                width="500px"
                :visible.sync="addFormVisible"
                center
                :append-to-body="true"
                :lock-scroll="false"
                class="add-form"
            >
                <el-form :model="addForm" ref="addForm" label-width="100px" :label-position="labelPosition">
                    <el-form-item label="文件名：">
                        <el-input v-model="addForm.filesName" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="addFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="sumbitAddRow">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
// import PDF from 'pdfjs-dist'
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
    data(){
        return{
            pageTitle:'',
            // listData:[],
            groupId:"",
            bars:[],
            cuid:'',
            curFile:{
                type:'',
                materiaType:'',
                groupId:'',
                entProjectId:'',
                attachment:'',
                attachmentName:'',
                attachmentType:'',
                userId:'',
                userName:'',
            },
            // fileList:[],
            uploadUrl:base.url+"/upload/uploadPhoto",//上传地址
            uploadHead:{  //上传接口header
                accessToken:this.$store.state.token
            },
            entProjectId:'',
            dataList:[],
            pages: [],
            // pdfDoc: null,
            addFormVisible:false,
            addForm:{
                filesName:""
            },
            labelPosition:'right',
            //fileName:'',
            wordUrl:'',//word文档地址
            nodeName:[],
            attachmentType:'',
            type:'',
            materiaType:'',
            baseNum:0,
        }
    },
    mounted() {
        this.groupId = this.$store.state.groupId;
        if(''==this.groupId){
            this.$store.commit('setGroupId');
            this.groupId = this.$store.state.groupId;
        }
        this.getData()
    },
    methods:{
        //获取文件夹数据
        getData(){
            var that = this
            myHttp.selectFolder({
                filesType:'1',
                type:'7',
                groupId:this.groupId,
                userType:util.session.get('roleId')
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.Files||[]
                    for(var j=0;j<list.length;j++){
                        // list[j].fileType = list[j].attachment&&''!=list[j].attachment?that.getImg(list[j].attachment):'0'
                        list[j].fileType = '0'
                    }
                    that.dataList = list
                }
                that.getFile()
            })
        },
        //获取文件
        getFile(){
            var that = this
            myHttp.selectFolder({
                filesType:'2',
                type:'7',
                groupId:this.groupId,
                userType:util.session.get('roleId')
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.Files||[]
                    for(var j=0;j<list.length;j++){
                        list[j].fileType = list[j].filesAddress&&''!=list[j].filesAddress?that.getImg(list[j].filesAddress):'5'
                        that.dataList.push(list[j])
                    }
                }
            })
        },
        
        //获取图片
        getImg(url){
            // 1:word   2:excel    3:pdf     4:img   5:undefined
            var result = '';
            var list = url.split('.')
            var str = list[list.length-1]
            if(base.docType.indexOf(str)>=0){
                result = '1'
            }else if(base.imgType.indexOf(str)>=0){
                result = '4'
            }else if(base.excelType.indexOf(str)>=0){
                result = '2'
            }else if(base.pdfType.indexOf(str)>=0){
                result = '3'
            }else{
                result = '5'
            }
            return result
        },
        //查看
        handleEdit(index,row){
            // this.$router.push('/checkDetail/'+row.id+'/'+row.type)
        },
        
        //展示
        setCuid(row){
            this.cuid = row.id
            this.getData()
        },
        //返回
        goBack(){
            this.$router.go(-1);
        },

        /**申报材料 */
        //上传成功
        fileSuccess1(res,file){
            if(res.code==200){
                var name = file.name.split('.')
                name.pop()
                name = name.join();
                var obj = {
                    filesType:'2',
                    type:'7',
                    filesName:name,
                    filesAddress:res.data.saveUrls,
                    filseCapacity:file.size,
                    groupId:this.groupId,
                    userType:util.session.get('roleId'),
                    createBy:util.session.get('user').id
                }
                this.submitFun(obj)
            }else{
                this.$message.error(resp.msg);
            }
            
        },

        /**
         * 添加方法
         */
        submitFun(data){
            let that = this
            myHttp.addFolderFiles(data).then(function(resp){
                if(resp.data.code=='200'){
                    that.$message({type: 'success',message: '文件添加成功!'});
                    that.getData()
                }else{
                    that.$message.error(resp.data.msg);
                }
            })
        },

        //查看文档
        showFile(url,name){
            var that = this
            window.open(base.fileView+'/onlinePreview?url='+encodeURIComponent(base.httpCtx+url),"_blank");
            
        },

        //查看文档下面的文件
        showChild(id,name){
            //this.$router.push('/desModel/'+this.cuid+'/'+this.materiaType+'/'+this.attachmentType+'/'+this.entProjectId+'/'+id)
            this.$router.push('/speBankFile/'+id+'/'+name)
        },
        
        //下载文档
        downFile(url){
            window.open(base.httpCtx+url)
        },

        //添加文件夹
        sumbitAddRow(){
            var that = this
            if(this.addForm.filesName==''){
                this.$message.error('请输入文件名称');
                return
            }
            this.addForm.filesType = '1'
            this.addForm.type = '7'
            this.addForm.groupId = this.groupId
            this.addForm.userType = util.session.get('roleId')
            this.addForm.createBy = util.session.get('user').id
            // this.addForm.parentId = ''
            myHttp.addFolderFiles(this.addForm).then(function(resp){
                if(resp.data.code=='200'){
                    that.$message.success('添加成功');
                    that.addFormVisible = false
                    that.getData()
                }else{
                    that.$message.error(resp.data.msg);
                }
            })
        },

    }
}
</script>
<style scoped>
    .contain{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .header-box{
        padding: 15px 20px;
        height: 70px;
        width: 100%;
        box-shadow: 1px 2px 3px 2px #ddd;
        background: #fff;
        box-sizing: border-box;
        position: relative;
        text-align: left;
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #2058D9;
        justify-content: space-between;
        justify-items: space-between;
    }
    .box{
        margin-top: 15px;
        width: 100%;
        height: calc( 100% - 70px );
    }
    .box-content{
        width: 100%;
        height: calc( 100% - 20px );
        background: #fff;
        overflow: auto;
        display: flex;
        align-content: flex-start;
    }
    .build-bar {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 80px;
        background: #fff;
        border-bottom: 3px solid #17b2fe;
        padding: 0 20px;
    }
    .box-content .el-button{
        background: #FFF;
        border: 1px solid #DCDFE6;
        color: #606266;
    }
    .primary{
        background-color: #17b2fe;
        border-color: #17b2fe;
        color: #fff;
    }
    .table-item{
        width: 100%;
        min-height: 50px;
        display: flex;
        border-bottom: 15px solid #ecf0f5;
        background: #fff;
    }
    .flex-wrap{
        display: flex;
        flex-wrap: wrap;
    }
    .item-con{
        padding: 10px;
    }
    .item-con p{
        margin: 0;
        margin-bottom: 15px;
        width: 100%;
        text-align: center;
        font-size: 14px;
    }
    .item-con img{
        cursor: pointer;
    }
    .table-item-sec{
        width: 100%;
        height: 50px;
        background: #17B2FE;
        color: #fff;
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 15px solid #ecf0f5;
    }
    .nowrap {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
</style>
<style>
    .build-bar span{
        margin-left: 0;
    }
    .el-table td, .el-table th{
        text-align: center;
    }
    /* .el-dialog{
        width: 500px;
    } */
</style>